// you can use this file when you want to exclude certain imports from happening
// in certain places. E.g. when a client side script is importing a server side
// module when it shouldn't. See where this is used in the next.config.js for
// more examples.
module.exports = {};
